// Runtime webpack config
import '../../other/WebpackConfig';

import '../../../scss/map.mp.nlnl.scss';

// i18n
import i18n from '../../i18n/nl-NL';

import map from './map';

map(i18n);
